import React from 'react';

const TermsAndConditions = () => {

  return (
    <div className="terms-and-conditions">
      <p>
        View the {' '}
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.homedepot.com/c/path-to-pro-network-terms-conditions"
          data-testid="terms-and-conditions"
        >
          Terms & Conditions {' '}
        </a>
        for the Path to Pro Network
      </p>
    </div>
  );
};

export default TermsAndConditions;
